export const validEmailRegex =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i

export const validUrlRegex =
  /^(https?:\/\/)?([\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?|\w+:(\/\/)?[\w.-]+)$/i

export const validNGPhoneRegex = /^(?!(\d)\1{9}$)[7-9][01]\d{8}$/

export const hexToBase64 = str => {
  return btoa(
    String.fromCharCode.apply(
      null,
      str
        .replace(/\r|\n/g, "")
        .replace(/([\da-fA-F]{2}) ?/g, "0x$1 ")
        .replace(/ +$/, "")
        .split(" ")
    )
  )
}

export const getReference = () => {
  let text = ""
  let possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-.="
  for (let i = 0; i < 15; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  return text
}

export const base64ToHex = str => {
  for (
    var i = 0, bin = atob(str.replace(/[ \r\n]+$/, "")), hex = [];
    i < bin.length;
    ++i
  ) {
    var tmp = bin.charCodeAt(i).toString(16)
    if (tmp.length === 1) tmp = "0" + tmp
    hex[hex.length] = tmp
  }
  return hex.join("")
}

export const closeModalOnClick = event => {
  document.querySelector(".modal-backdrop").addEventListener("click", e => {
    const isVisible = elem =>
      !!elem &&
      !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length)

    Array.from(
      document.querySelectorAll(".modal-backdrop .modal-content")
    ).forEach(element => {
      if (!element.contains(e.target) && isVisible(element)) {
        event()
      }
    })
  })
}

export const closeMobileModalOnClick = event => {
  document.querySelector(".kuda-mobile--menu").addEventListener("click", e => {
    const isVisible = elem =>
      !!elem &&
      !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length)

    Array.from(document.querySelectorAll(".kuda-menu--wrap")).forEach(
      element => {
        if (!element.contains(e.target) && isVisible(element)) {
          event()
        }
      }
    )
  })
}

export const fallbackCopyTextToClipboard = text => {
  var textArea = document.createElement("textarea")
  textArea.value = text
  textArea.style.position = "fixed" //avoid scrolling to bottom
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand("copy")
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err)
  }

  document.body.removeChild(textArea)
}

export const copyTextToClipboard = text => {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text)
    return
  }
  navigator.clipboard.writeText(text).then(
    function () {},
    function (err) {
      console.error("Async: Could not copy text: ", err)
    }
  )
}

export const currentYear = () => {
  var dt = new Date() //Date constructor
  return dt.getUTCFullYear()
}

export const formatBalance = (
  amount,
  decimalCount = 2,
  decimal = ".",
  thousands = ","
) => {
  try {
    if (amount || amount === 0) {
      decimalCount = Math.abs(decimalCount)
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount
      amount = isNaN(amount) ? 0 : amount
      const negativeSign = amount < 0 ? "-" : ""
      let i = parseInt(
        (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
      ).toString()
      let j = i.length > 3 ? i.length % 3 : 0
      return (
        negativeSign +
        (j ? i.substr(0, j) + thousands : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
        (decimalCount
          ? decimal +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
          : "")
      )
    }
    return "0,00"
  } catch (e) {
    console.log(e)
  }
}

export const validateEmail = value => {
  return !validEmailRegex.test(value) ? "Email must be valid" : ""
}

export const validateWebsite = value => {
  return !validUrlRegex.test(value) ? "Website must be valid" : ""
}

export const validateNGphoneNumber = value => {
  return !validNGPhoneRegex.test(value) ? "Invalid phone number" : ""
}

export const formatPathString = path => {
  let formatedPath = path
    ?.replace(/[`~!@#$%^*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, " ")
    .trim()
  formatedPath = formatedPath
    ?.split(" ")
    .map(word => word.toLowerCase().trim())
    .filter(word => word !== "")
    .join("-")
  const newPath = `${formatedPath?.replace(/ /g, "-")}`
  return newPath
}

export const titleCase = str => {
  var splitStr = str.toLowerCase().split(" ")
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
  }
  // Directly return the joined string
  return splitStr.join(" ")
}

// utm for GTM tracking
export const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "fbclid",
  "ttclid",
]

export const captureUTMParams = () => {
  if (typeof window === "undefined") return

  const params = new URLSearchParams(window.location.search)
  const utmParams = {}

  UTM_KEYS.forEach(key => {
    const value = params.get(key)
    if (value) utmParams[key] = value
  })

  if (Object.keys(utmParams).length > 0) {
    sessionStorage.setItem("utm_params", JSON.stringify(utmParams))
  }
}

export const getStoredUTMParams = () => {
  if (typeof window === "undefined") return {}
  const raw = sessionStorage.getItem("utm_params")
  try {
    return raw ? JSON.parse(raw) : {}
  } catch (e) {
    return {}
  }
}

export const trackGTMClick = ({eventName, cta_text, path, ...props}) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    ...props,
    event: eventName,
    cta_text,
    page_url: path,
  })
}
